<template>
  <div class="page">
    <!-- <img src="../../assets/img/3.png" ref="img3" class="img3">
    <img src="../../assets/img/2.png" class="img2" :style="img2Obj">
    <img src="../../assets/img/1.png" class="img1">
    <img src="../../assets/img/4.png" class="img4">
    <img src="../../assets/img/logo.png" class="logo"> -->
    <div class="login-wrapper">
      <div class="login-content">
        <div class="logo2-box">
          <img src="../../assets/img/logo2.png" class="logo2">
        </div>

        <!-- <div class="title">
          登录
        </div>
        <div class="sub-title">
          欢迎登录清露
        </div> -->

        <el-form label-position="top" ref="loginForm" label-width="80px" :model="loginForm" hide-required-asterisk
          :rules="loginRules">
          <el-form-item label="账号" prop="username" class="password-item">
            <el-input :disabled="loading" v-model="loginForm.username" placeholder="请输入账号"></el-input>
            <img src="../../assets/img/yes.png" v-show="loginForm.username.length > 0" class="password-icon" alt="">
          </el-form-item>
          <el-form-item label="密码" prop="password" class="password-item">
            <el-input :disabled="loading" v-model="loginForm.password" :type="showpass ? '' : 'password'"
              placeholder="请输入密码"></el-input>
            <img src="../../assets/img/p2.png" v-show="!showpass" class="password-icon eyes" @click="showpass = true">
            <img src="../../assets/img/p1.png" v-show="showpass" class="password-icon eyes" @click="showpass = false">
          </el-form-item>
          <el-form-item>
            <div>
              <el-button :loading="loading" class="login-btn" type="primary" @click="submitForm('loginForm')" :disabled="!isAllowLogin">
                {{ loading ? '登录中...' : '登录' }}
              </el-button>
            </div>
            <div class="reset">
              <el-link @click="resetForm('loginForm')" type="primary">重置</el-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      showpass: false,
      loading: false,
      loginForm: {
        username: "",
        password: ""
      },
      img2Obj: {},
      loginRules: {
        username: [{
          required: true, message: "输入账号有误", trigger: 'blur'
        }],
        password: [{
          required: true, message: "密码不能为空", trigger: 'blur'
        }]
      }
    };
  },
  mounted() {
    window.addEventListener('keyup', this.handlerKeyUp)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handlerKeyUp)
  },
  computed: {
    ...mapState(['browerInfo','isAllowLogin'])
  },
  methods: {
    initImg2Style() {
      setTimeout(() => {
        const img3w = this.$refs.img3.width + 49
        this.img2Obj = { left: `${img3w}px` }
      }, 200);
    },
    handlerKeyUp(e) {
      if (e.code == 'Enter') {
        this.submitForm('loginForm')
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true
          const [err, res] = await this.$http.post("user/login", this.loginForm);

          if (err) {
            this.loading = false
            return;
          }
          localStorage.setItem("token", res.token);
          localStorage.setItem("user_info", JSON.stringify(res.user_info));
          const [err1, res1] = await this.$http.get("home/course/cate");
          if (err1) {
            this.loading = false
            localStorage.removeItem('token')
            localStorage.removeItem('user_info')
            return;
          }

          localStorage.setItem('courseCate', JSON.stringify(res1.list))

          this.$router.push("/count_center");
          document.getElementById('app').style.background = '#f7f7f7'
          this.loading = false
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-size: cover;
  background: #fff;

  .login-wrapper {
    background-image: url(../../assets/img/5.png);
    background-repeat: no-repeat;
    position: absolute;
    right: 0;
    top: 0;
    background-size: cover;
    width: 100%;
    height: 100%;
    z-index: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .login-content {

      // width: 492px;
      // height: 560px;
      background: #FFFFFF;
      border-radius: 16px;
      padding: 62px 42px 24px;
      box-sizing: border-box;

      .logo2-box {
        text-align: center;

        .logo2 {
          height: 30px;
          margin-bottom: 45px;
        }
      }


      .title {
        color: #333333;
        font-size: 36px;
        font-weight: bold;
        margin-bottom: 9px;
      }

      .sub-title {
        color: #777E90;
        font-size: 14px;
        margin-bottom: 49px;
      }
    }
  }

  .img3 {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100%
  }

  .img4 {
    position: absolute;
    bottom: 0;
    width: 450px;
    height: 180px;
    right: 0;
  }

  .img2 {
    position: absolute;
    bottom: 0;
    left: -300px;
    width: 244px;
    z-index: 1;
  }

  .img1 {
    position: absolute;
    top: 0;
    right: 0;
    width: 264px;
    z-index: 1;
  }

  .logo {
    position: absolute;
    width: 317px;
    top: 65px;
    left: 57px;
  }
}

/deep/ .el-input__inner {
  background: #FAFAFA;
  border-color: #DCDFE6;
  width: 350px;
  height: 48px;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
  color: #333333;
}

.login-btn {
  width: 350px;
  border-radius: 4px;
  background: #2AB18B;
  border-color: #2AB18B;
}

.reset {
  text-align: center;
}

/deep/ .el-link {
  line-height: 20px;
}

/deep/ .el-form-item {
  margin-bottom: 18px;
}

/deep/ .el-form-item:nth-child(2) {
  margin-bottom: 51px;
}

/deep/ .el-form-item__error {
  right: 0;
  color: #F56C6C;
}

.password-item {
  position: relative;

  .password-icon {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 16px;
    top: 16px;
  }

  .eyes {
    cursor: pointer;
  }
}
</style>